module.exports = __webpack_public_path__ + "static/img/server6.03fc6d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/server6.png
// module id = D2T/
// module chunks = 1